import { observable, runInAction } from "mobx";
import { PresenceState, PresenceUpdate } from "../Types";

export const presenceState = observable<PresenceState>({});

export function updateWithPresenceUpdate(
  clientId: number,
  presenceUpdate: PresenceUpdate
) {
  runInAction(() => {
    if (presenceUpdate.name !== undefined) {
      presenceState[clientId].name = presenceUpdate.name;
    }
    if (presenceUpdate.c !== undefined) {
      presenceState[clientId].cursor = presenceUpdate.c;
    }
    if (presenceUpdate.p === null) {
      delete presenceState[clientId].paneId;
      delete presenceState[clientId].textRange;
    } else if (presenceUpdate.p !== undefined) {
      if (
        presenceState[clientId].paneId !== presenceUpdate.p &&
        presenceUpdate.t === undefined
      ) {
        delete presenceState[clientId].textRange;
      }
      presenceState[clientId].paneId = presenceUpdate.p;
    }
    if (presenceUpdate.t !== undefined) {
      if (presenceUpdate.t === null) {
        delete presenceState[clientId].textRange;
      } else {
        presenceState[clientId].textRange = presenceUpdate.t;
      }
    }
  });
}

export function getPresencesForPaneId(paneId: string) {
  return Object.entries(presenceState).reduce<
    {
      clientId: string;
      textRange?: [from: number, to: number];
    }[]
  >((acc, [clientId, state]) => {
    if (state.paneId === paneId) {
      return [...acc, { clientId, textRange: state.textRange }];
    }
    return acc;
  }, []);
}
